import React from 'react';
import classNames from 'classnames';
import styles from './FJToolContentBG.module.less';

const FJToolContentBG = props => {
    const { style, children, active, className, upOrDown } = props;
    const classBtn = classNames(
        styles.content,
        className,
        active ? styles.active : null,
        upOrDown === 'up' && active ? styles.up : null,
        upOrDown === 'down' && active ? styles.down : null,
    );

    return (
        <div style={style} className={classBtn}>
            {children}
        </div>
    );
};

export default FJToolContentBG;
